import React from 'react';
import { Fab, Zoom } from '@mui/material';
import { Chat as ChatIcon, Close as CloseIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

// ============================================================================
// Interfaces
// ============================================================================
interface ChatBubbleProps {
  onClick: () => void;
  isOpen: boolean;
}

// ============================================================================
// Component
// ============================================================================
const ChatBubble: React.FC<ChatBubbleProps> = ({ onClick, isOpen }) => {
  const theme = useTheme();

  return (
    <Zoom in={true}>
      <Fab
        color="primary"
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1000
        }}
      >
        {isOpen ? <CloseIcon /> : <ChatIcon />}
      </Fab>
    </Zoom>
  );
};

export default ChatBubble; 